import {AdminRols} from "./AdminRols";

export class AdminUser {
    id: number=0;
    userName: string = '';
    mobile: string = '';
    password: string = '';
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    active: boolean = true;
    admin: boolean = false;
    rols: Array<AdminRols> = new Array<AdminRols>();
     apps: Array<any> = new Array<any>();
}
